module.exports = __webpack_public_path__ + "static/media/bKash_Logo_Icon_Outlined.6bbbe291.svg";